<template>
    <div class="tw:p-6 tw:max-w-lg">
        <h2 class="tw:text-lg tw:font-semibold tw:text-gray-800 tw:mb-4">Compañía Fiscal</h2>

        <div v-if="loading" class="tw:text-sm tw:text-gray-500">Cargando compañías...</div>

        <div v-else>
            <div class="tw:mb-4">
                <label class="tw:block tw:text-sm tw:font-medium tw:text-gray-700 tw:mb-1" for="company-select">
                    Compañía emisora de recibos
                </label>
                <select
                    id="company-select"
                    v-model="selectedCompanyId"
                    class="tw:w-full tw:border tw:border-gray-300 tw:rounded-md tw:px-3 tw:py-2 tw:text-sm focus:tw:outline-none focus:tw:ring-2 focus:tw:ring-blue-500"
                >
                    <option :value="null">Sin compañía</option>
                    <option v-for="company in companies" :key="company.id" :value="company.id">
                        {{ company.nombre }}
                    </option>
                </select>
            </div>

            <div v-if="error" class="tw:text-sm tw:text-red-600 tw:mb-3">{{ error }}</div>

            <button
                class="tw:bg-blue-600 hover:tw:bg-blue-700 disabled:tw:opacity-50 tw:text-white tw:text-sm tw:font-medium tw:px-4 tw:py-2 tw:rounded-md tw:transition-colors"
                :disabled="saving"
                @click="save"
            >
                {{ saving ? 'Guardando...' : 'Guardar' }}
            </button>
        </div>
    </div>
</template>

<script setup>
    import { useCompaniaFiscalDeportistas } from '@/composables/admin/configuracion/deportistas/useCompaniaFiscalDeportistas';

    const { companies, selectedCompanyId, loading, saving, error, save } = useCompaniaFiscalDeportistas();
</script>
